var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 1.1665C4.11673 1.1665 1.5 3.78324 1.5 6.99984C1.5 10.2165 4.11673 12.8332 7.33333 12.8332C10.55 12.8332 13.1667 10.2165 13.1667 6.99984C13.1667 3.78324 10.55 1.1665 7.33333 1.1665ZM8.62542 10.0546C8.30412 10.1809 7.19042 10.7128 6.54875 10.1474C6.35724 9.97921 6.26193 9.76583 6.26193 9.50671C6.26193 9.02155 6.42141 8.59864 6.7087 7.58317C6.75922 7.39114 6.82099 7.14229 6.82099 6.94489C6.82099 6.60416 6.69167 6.51375 6.3412 6.51375C6.17005 6.51375 5.98048 6.57447 5.80889 6.63864L5.90368 6.25025C6.28625 6.09468 6.76651 5.9051 7.17776 5.9051C7.79463 5.9051 8.2487 6.2128 8.2487 6.79812C8.2487 6.96676 8.21953 7.26234 8.15828 7.4665L7.80338 8.72166C7.73 8.97541 7.59729 9.53489 7.80292 9.70067C8.00516 9.86447 8.48396 9.7775 8.72021 9.66614L8.62542 10.0546ZM8.03917 5.05539C7.63667 5.05539 7.31 4.72873 7.31 4.32623C7.31 3.92373 7.63667 3.59706 8.03917 3.59706C8.44167 3.59706 8.76833 3.92373 8.76833 4.32623C8.76833 4.72873 8.44167 5.05539 8.03917 5.05539Z",
    fill: "#6F6E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/informationIcon.78bd5445.svg";
export { ForwardRef as ReactComponent };